import React, {useContext} from 'react';
import classnames from 'classnames';
import { NeuroMessage } from "@ignitesales/neuro-application";
import GuideContext from "../GuideContext";
import ReactSVG from 'react-svg';

const Footer = ({logout, user, children}) => {
  const guideContext = useContext(GuideContext);
  const employee = user && user.assignment && user.assignment.employee ? user.assignment.employee : null;
  const branch = user && user.assignment && user.assignment.branch ? user.assignment.branch.name : null;

  const onLogout = () => {
    logout && logout();
    setTimeout(() => location.reload(), 500);
  };

  const { isBranchGuide } = useContext(GuideContext);
  const bemClass = 'footer';
  const contentClasses = classnames(`${bemClass}`, {
    [`${bemClass}__branch`]: isBranchGuide,
    [`${bemClass}__online`]: !isBranchGuide,
  });

  return <footer className={contentClasses}>
    {children}
    <p className={`${bemClass}__content`}>
      <NeuroMessage id="footer.copyright" />
      <ReactSVG src="/classpath/assets/images/icon-equal-housing.svg" wrapper="span" />
      <NeuroMessage id="footer.copyrightTwo" />
      { employee && guideContext.isBranchGuide ?
        <a href='#!' className='footer__logout' onClick={onLogout}>
          { `${employee.firstName} ${employee.lastName}` } | { branch } | <NeuroMessage id='logout'/>
        </a>
        : null
      }
    </p>
  </footer>;
};

export default Footer;
